<template>
  <scroll-bar>
     <!--<transition name="el-fade-in-linear">-->
      <!--<div style="width:100%;height:50px;border-bottom:1px solid #4D4D48">-->
        <!--<img :src="headerlogo" alt="header-logo.png" :width="widthd" :height="heightd" :style="styled" :v-show="show">-->
      <!--</div>-->
      <!--</transition>-->
    <el-input v-show="sidebar.opened" class="menu-filter" prefix-icon="el-icon-search" v-model="searchVal" placeholder="请输入要查找的菜单"></el-input>
    <el-menu ref="elMenu" mode="vertical" unique-opened :default-openeds="openeds" :default-active="$route.path" :collapse="isCollapse" background-color="#30323A" text-color="#fff" active-text-color="#e60012">
      <sidebar-item :routes="filterUserMenus"></sidebar-item>
    </el-menu>


  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarItem from './sidebarItem'

export default {
  data() {
    return {
      headerlogo: '',
      widthd: '',
      heightd: '',
      styled: '',
      show: '',
      imgPath: [{
        url: require('@/assets/images/header-logo.png')
      }, {
        url: require('@/assets/images/header-logo_mini.png')
      }],
      searchVal: '',
      openeds: []
    }
  },
  components: { sidebarItem },
  methods: {
    findFilterMenus(menus) {
      let childrens = []
      childrens.length = menus.length
      childrens.fill([])
      return menus.map((j, k) => {
        childrens[k] = j.childrens ? JSON.parse(JSON.stringify(j.childrens)):[]
        return {
          ...j,
          childrens: j.childrens ? this.findFilterMenus(j.childrens) : []
        }
      }).filter((v,k) => {
        if(v.childrens && v.childrens.length) {
          return true
        }else{
          let bool = v.label.includes(this.searchVal)
          bool ? v.childrens = childrens[k] : null
          return  bool
        }
      })
    }
  },
  // mounted() {
  //   setTimeout(() => {
  //     // this.openeds.push("2525212232/dataAuthority/dataSet")
  //     console.log(this.$refs,"123")
  //     this.$refs.elMenu.open("11/")
  //   }, 2000)
  // },
  watch: {
    searchVal(n) {
      this.openeds = []
    }
  },
  computed: {
    ...mapGetters(['userMenus', 'sidebar']),
    filterUserMenus() {
      if(this.searchVal) {
        let filterMenus = this.findFilterMenus(this.userMenus)
        let arr = []
        function pushItem(menus) {
          menus.forEach(item => {
            arr.push(item.id + item.level + item.url)
            if(item.childrens && item.childrens.length) {
              pushItem(item.childrens)
            }
          })
        }
        pushItem(filterMenus)
        this.openeds = arr
        return filterMenus
      }
      this.openeds = []
      return this.userMenus
    },
    routes() {
      const routes = [
        {
          path: '/form',
          meta: { title: '菜单和表格', icon: 'example' },
          children: [
            {
              path: 'index',
              name: 'Form',
              meta: { title: '表单', icon: 'form' }
            },
            {
              path: 'table',
              name: 'Table',
              meta: { title: '表格', icon: 'form' }
            }
          ]
        }
      ]
      return routes
    },
    isCollapse() {
      if (this.sidebar.opened) {
        this.headerlogo = this.imgPath[0].url
        this.widthd = '80px'
        this.heightd = '29px'
        this.styled = 'margin:12px 24px'
        this.show = true
      } else {
        this.headerlogo = this.imgPath[1].url
        this.widthd = '18px'
        this.heightd = '18px'
        this.styled = 'margin: 25px 5px 1px 8px;'
        this.show = false
      }
      return !this.sidebar.opened
    }
  }
}
</script>
<style lang="scss" scoped>
#app .menu-filter{
  padding:2px 4px;
  transition: all .2s;
  background-color: #30323a;
  position: fixed;
  top:40px;
  width: 200px;
  z-index: 2;
  box-shadow: 0px 2px 4px 2px #30323766;
  /deep/ .el-input__inner{
    background: #30323a;
    border: none;
    height: 32px;
    line-height: 32px;
    color:#fff;
    transition: all .2s;
  }
  /deep/ .el-input__inner:focus, /deep/ .el-input__inner:hover{
    background: #444b63;
  }

}
</style>
